import { useRouter } from "next/navigation";

import { Button } from "@/components/ui";

export default function FormNotFound() {
  const router = useRouter();

  return (
    <div className="z-10 flex h-full w-full flex-col items-center justify-center p-8">
      <div className="max-w-md rounded-lg  p-8 text-center shadow-md">
        <h2 className="mb-4 text-h2 text-foreground">Form Not Found</h2>
        <p className="mb-6 text-foreground-secondary">
          The form you are looking for could not be found. Please make sure you
          are accessing the correct link.
        </p>
        <Button onClick={() => router.back()} variant="secondary">
          Go Back
        </Button>
      </div>
    </div>
  );
}
